import { render, staticRenderFns } from "./TableFormula.vue?vue&type=template&id=509d204a"
import script from "./TableFormula.vue?vue&type=script&lang=js"
export * from "./TableFormula.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports